enum MedicalNoteViewMode {
    View = 1,
    Edit = 2
}

enum MedicalNoteActionType {
    Unapprove = 1,
    Delete = 2
}

export { MedicalNoteActionType, MedicalNoteViewMode };
